import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AuthService } from './authService';

export function usePostLogout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => AuthService.postLogout().then((response) => response.data),
    onSettled: () => {
      queryClient.removeQueries();
    },
  });
}
